
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artists/[slug]",
      function () {
        return require("private-next-pages/artists/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artists/[slug]"])
      });
    }
  